import React, { useState, useRef, useEffect } from "react";
import "./OuterFiltersDropDown.css";
import { DownIcon, UpIcon } from "../../components/FilterModal/Icons.tsx";

export default function PaymentMethodDropDown({ paymentMethod, setPaymentMethod, filters }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();
  const itemRef = useRef();

  // Add "All Methods" as the first option
  const paymentMethodOptions = [
    { label: "All Payment Methods", value: "All Methods" },
    { label: "CASH", value: "cash" },
    { label: "DEBIT", value: "debit" },
    { label: "VISA", value: "visa" },
    { label: "MASTERCARD", value: "mastercard" },
    { label: "PREAUTH", value: "preauth" }
  ];

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      const activeItem = itemRef.current?.querySelector(".active");
      if (activeItem && itemRef.current) {
        itemRef.current.scrollTop = activeItem.offsetTop - 72;
      }
    }
  }, [isOpen]);

  // Use filters.paymentMethod as the source of truth
  const currentPaymentMethod = filters.paymentMethod || paymentMethod;

  // Find the display label for the current value
  const getCurrentLabel = () => {
    if (!currentPaymentMethod) return "All Payment Methods";
    const option = paymentMethodOptions.find(opt => opt.value === currentPaymentMethod);
    return option ? option.label : currentPaymentMethod.toUpperCase();
  };

  return (
    <div className={`dropdown-wrapper`} ref={dropdownRef}>
      <button
        style={{ fontSize: "12.5px" }}
        className={`TransactionsfilterPaymentMethodDropDownBtn ${
          filters.paymentMethod && filters.paymentMethod !== "All Payment Methods" ? "active" : ""
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {getCurrentLabel()}
        {!isOpen ? <DownIcon /> : <UpIcon />}
      </button>
      {isOpen && (
        <div className="dropdown-list" ref={itemRef}>
          {paymentMethodOptions.map((option, index) => (
            <button
              key={index}
              onClick={() => {
                setPaymentMethod(option.value);
                setIsOpen(false);
              }}
              className={`dropdown-item ${option.value === currentPaymentMethod ? "active" : ""}`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}